var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSdcBox = function SvgSdcBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58887 10.988C9.14115 10.988 9.58887 11.4357 9.58887 11.988C9.58887 13.6448 10.9321 14.988 12.589 14.988C14.2458 14.988 15.589 13.6448 15.589 11.988C15.589 11.4357 16.0367 10.988 16.589 10.988H20.277L18.5278 4H6.64996L4.90087 10.988H8.58887ZM4.58887 12.988H7.68889C8.15218 15.2702 10.1701 16.988 12.589 16.988C15.0079 16.988 17.0257 15.2702 17.489 12.988H20.589V19.9892L4.58887 19.9988L4.58887 12.988ZM22.589 11.988V19.9892C22.589 21.0933 21.6943 21.9885 20.5902 21.9892L4.59007 21.9988C3.48503 21.9995 2.58887 21.1038 2.58887 19.9988V11.988L4.70982 3.51438C4.9326 2.62431 5.73244 2 6.64996 2H18.5278C19.4453 2 20.2451 2.6243 20.4679 3.51436L22.589 11.988Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSdcBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sdc-box.a6f13230.svg";
export { ForwardRef as ReactComponent };